import React from "react";
import { useAuth } from "../../modules/auth";
import { EventDailyInsightWidget } from './components/EventDailyInsightWidget';
import { DashboardMarketInsightWidget } from './components/DashboardMarketInsightWidget';
import { SeoAnalysisDashboardWidget } from './components/SeoAnalysisDashboardWidget';

const Dashboard: React.FC = () => {
  const { currentUser } = useAuth();
  return (
    <>
      {/* Container principale */}
      <div id="kt_app_content_container" className="app-container container-xxl">
        <div className="card mb-10">
          <div className="card-body d-flex flex-column justify-content-center align-items-center py-10">
            <h2 className="fs-2x fw-bold mb-0">{currentUser?.selectedProject?.brandName || 'Nessun Progetto Selezionato'}</h2>
            <p className="text-gray-400 fs-4 fw-semibold pt-7 mb-0">Presto qui trovi altri widget che ti aiutano a gestire la tua attività di marketing.</p>
          </div>
        </div>

        <div className="row g-5 g-xl-10">

          {/* Colonna: Analisi */}
          <div className="col-xl-4">
            <div className="card card-flush h-xl-100 bg-light-primary border-primary border-bottom border-dashed border-2">
              <div className="card-header bg-primary min-h-auto py-5 mb-0 align-items-center rounded-top">
                <div className="d-flex align-items-center">
                  <i className="ki-outline ki-chart-line-star fs-2x text-white me-4"></i>
                  <div className="d-flex flex-column">
                    <span className="card-label fw-bold fs-2 text-white lh-1">Analisi</span>
                    <span className="text-white opacity-75 fw-semibold fs-7 pt-1">Scenario mercato</span>
                  </div>
                </div>
              </div>
              <div className="card-body pt-5">
                <p className="text-gray-800 fw-semibold fs-6 mb-7">
                  Dati, segnali e metriche che descrivono il contesto competitivo attuale.
                </p>
                <EventDailyInsightWidget />

                <SeoAnalysisDashboardWidget />

                <div className="card card-custom bg-white shadow-sm mb-5 p-6 border-0">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <i className="ki-outline ki-price-tag fs-2x text-primary mb-3"></i>
                    <span className="text-gray-800 fw-bold fs-6 mb-1">Monitoraggio Prezzi</span>
                    <span className="text-gray-400 fw-semibold fs-7">Prossima attivazione</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Colonna: Ragionamento */}
          <div className="col-xl-4">
            <div className="card card-flush h-xl-100 bg-light-warning border-warning border-bottom border-dashed border-2">
              <div className="card-header bg-warning min-h-auto py-5 mb-0 align-items-center rounded-top">
                <div className="d-flex align-items-center">
                  <i className="ki-outline ki-abstract-26 fs-2x text-white me-4"></i>
                  <div className="d-flex flex-column">
                    <span className="card-label fw-bold fs-2 text-white lh-1">Ragionamento</span>
                    <span className="text-white opacity-75 fw-semibold fs-7 pt-1">Cosa significa</span>
                  </div>
                </div>
              </div>
              <div className="card-body pt-5">
                <p className="text-gray-800 fw-semibold fs-6 mb-7">
                  Interpretazione AI dei dati per individuare pattern, anomalie e opportunità.
                </p>
                <DashboardMarketInsightWidget />

                <div className="card card-custom bg-white shadow-sm mb-5 p-6 border-0">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <i className="ki-outline ki-notification-status fs-2x text-warning mb-3"></i>
                    <span className="text-gray-800 fw-bold fs-6 mb-1">Analisi anomalie</span>
                    <span className="text-gray-400 fw-semibold fs-7">Prossima attivazione</span>
                  </div>
                </div>

                <div className="card card-custom bg-white shadow-sm mb-5 p-6 border-0">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <i className="ki-outline ki-artificial-intelligence fs-2x text-warning mb-3"></i>
                    <span className="text-gray-800 fw-bold fs-6 mb-1">Spiegazioni AI</span>
                    <span className="text-gray-400 fw-semibold fs-7">Prossima attivazione</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Colonna: Azione */}
          <div className="col-xl-4">
            <div className="card card-flush h-xl-100 bg-light-success border-success border-bottom border-dashed border-2">
              <div className="card-header bg-success min-h-auto py-5 mb-0 align-items-center rounded-top">
                <div className="d-flex align-items-center">
                  <i className="ki-outline ki-rocket fs-2x text-white me-4"></i>
                  <div className="d-flex flex-column">
                    <span className="card-label fw-bold fs-2 text-white lh-1">Azione</span>
                    <span className="text-white opacity-75 fw-semibold fs-7 pt-1">Cosa fare</span>
                  </div>
                </div>
              </div>
              <div className="card-body pt-5">
                <p className="text-gray-800 fw-semibold fs-6 mb-7">
                  Decisioni operative, task e automazioni suggerite per agire sul mercato.
                </p>
                <div className="card card-custom bg-white shadow-sm mb-5 p-6 border-0">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <i className="ki-outline ki-compass fs-2x text-success mb-3"></i>
                    <span className="text-gray-800 fw-bold fs-6 mb-1">Azioni consigliate</span>
                    <span className="text-gray-400 fw-semibold fs-7">Prossima attivazione</span>
                  </div>
                </div>

                <div className="card card-custom bg-white shadow-sm mb-5 p-6 border-0">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <i className="ki-outline ki-check-square fs-2x text-success mb-3"></i>
                    <span className="text-gray-800 fw-bold fs-6 mb-1">Task automatici</span>
                    <span className="text-gray-400 fw-semibold fs-7">Prossima attivazione</span>
                  </div>
                </div>

                <div className="card card-custom bg-white shadow-sm mb-5 p-6 border-0">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <i className="ki-outline ki-electricity fs-2x text-success mb-3"></i>
                    <span className="text-gray-800 fw-bold fs-6 mb-1">Automazioni intelligenti</span>
                    <span className="text-gray-400 fw-semibold fs-7">Prossima attivazione</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
};

export default Dashboard;
